<template>
	<metainfo>
		<template v-slot:title="{content}">{{content}}</template>
	</metainfo>
	<router-view/>
	<modals-container/>
</template>

<style lang="scss"></style>

<script>
import axios from 'axios';
import lib from '@/lib';
import { useMeta } from 'vue-meta';
import { ModalsContainer } from 'vue-final-modal';

export default {
	name: 'App',
	mixins: lib.mixins,
	setup() {
		useMeta({
			title: '',
			htmlAttrs: {
				lang: 'ru',
				amp: true,
			},
		});
	},
	mounted(){
		window["appComponent"] = this;
		this.checkTokenInURL();
	},
	methods: {
		checkTokenInURL(){
			const urlParams = new URLSearchParams(window.location.search);
			const token = urlParams.get('token');
			const refresh_token = urlParams.get('refresh_token');
			const device_id = urlParams.get('device_id');
			if (token && refresh_token && device_id) {
				lib.localStorageSet('token', token);
				lib.localStorageSet('refresh_token', refresh_token);
				lib.localStorageSet('device_id', device_id);
				this.authModel.token = token;
				this.authModel.refresh_token = refresh_token;
				this.authModel.device_id = device_id;
				axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
				axios.defaults.headers.common['Refresh-Token'] = refresh_token;
				axios.defaults.headers.common['Device-ID'] = device_id;
				this.authModel.doInitData();
				this.$router.push('/');
			}
		},
	},
	components: {
		ModalsContainer,
	},
};
</script>
